import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAIuAuAEAK_lQsSwAopQuC__zaGZgsqNy0",
  authDomain: "visionary-code-project.firebaseapp.com",
  projectId: "visionary-code-project",
  storageBucket: "visionary-code-project.firebasestorage.app",
  messagingSenderId: "23423090692",
  appId: "1:23423090692:web:c86c3af35bfe278075f551",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
